import Pagination from '@mui/material/Pagination'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { CheckPoint, Floor } from 'interface'
import { useEffect, useState } from 'react'
import ReadMoreIcon from '@mui/icons-material/ReadMore'
import { useNavigate } from 'react-router-dom'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: 8,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 8,
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.focus,
  },
}))

interface Props {
  data: CheckPoint[]
  gps: boolean
  floor: Floor[]
}

const MAX_ITEM_IN_PAGE = 10
export default function EventTable({ data = [], gps, floor = [] }: Props) {
  const navigate = useNavigate()
  const [pagination, setPagination] = useState({
    curPage: 1,
    totalPage: 0,
  })
  useEffect(() => {
    if (data)
      setPagination({
        ...pagination,
        totalPage: Math.ceil(data.length / MAX_ITEM_IN_PAGE),
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPagination({
      ...pagination,
      curPage: value,
    })
  }
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }}>
          <TableHead>
            <TableRow>
              <StyledTableCell>No</StyledTableCell>
              <StyledTableCell>名称</StyledTableCell>
              {gps ? null : <StyledTableCell>フロア名</StyledTableCell>}
              <StyledTableCell>{gps ? '北緯' : 'Y座標(%)'}</StyledTableCell>
              <StyledTableCell>{gps ? '東経' : 'X座標(%)'}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .slice(
                (pagination.curPage - 1) * MAX_ITEM_IN_PAGE,
                pagination.curPage * MAX_ITEM_IN_PAGE
              )
              .map((point, i) => {
                return (
                  <StyledTableRow
                    key={i}
                    onClick={() => {
                      navigate(
                        '/event/' + point.eventId + '/update-point/' + point.id
                      )
                    }}
                  >
                    <StyledTableCell>{`${
                      (pagination.curPage - 1) * MAX_ITEM_IN_PAGE + i + 1
                    }`}</StyledTableCell>
                    <StyledTableCell>{point.name}</StyledTableCell>
              {gps ? null : <StyledTableCell>{floor.find((f) => f.id === Number((point.lat / 1000).toFixed(0)))?.floorName}</StyledTableCell>}
                    <StyledTableCell>
                      {gps ? point.lat : (point.lat % 1000).toFixed(3)}
                    </StyledTableCell>
                    <StyledTableCell>
                      {gps ? point.lng : (point.lng % 1000).toFixed(3)}
                    </StyledTableCell>
                  </StyledTableRow>
                )
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack my={1} alignItems="center">
        <Pagination
          count={pagination.totalPage}
          page={pagination.curPage}
          shape="rounded"
          onChange={handleChange}
        />
      </Stack>
    </>
  )
}
